export const DataFile = {
    "title": "Business Management - Easy as 123!",
    "columns": [
        {
            "title": "Other Enhancements in Release 6.0",
            "isNew": true,
            "items": [
              "Optimised Data Split",
              "Enhanced Profile Management",
              "Effortless Payroll Management and Tax Compliance",              
            ]
          },
      {
        "title": "Simple Accounting Management",
        "items": [
          "Pre-defined accounting groups and flexible chart of accounts",
          "Groups and ledgers management",
          "Multi-currency support",
          "Multiple companies",
          "Group company/consolidation of companies",
          "Post-dated transactions",
          "Multiple voucher numbering series for a voucher type"
        ]
      },
      {
        "title": "Flexible Purchase & Sales Management",
        "items": [
          "GST compliant invoice (Tax Invoice, Bill of Supply)",
          "Multiple billing formats",
          "Multiple price list & discount management",
          "Multiple mailing address",
          "Sales & Purchase orders processing",
          "Complete track of receipt (GRN) and delivery note (DC)"
        ]
      },
      {
        "title": "Inventory Management",
        "items": [
          "Unlimited stock groups and categorization",
          "Multi-Locations/godowns and batch management",
          "Alternate & compound units of measure",
          "Physical stock verification",
          "Manufacture and expiry date management",
          "Flexible units of measure",
          "Job costing",
          "Item cost tracking",
          "Re-order level",
          "Multiple stock valuation"
        ]
      },
      {
        "title": "Credit and Cash Flow Management",
        "items": [
          "Receivable and payable management",
          "Multiple bill settlement",
          "Ageing analysis",
          "Credit control utilities",
          "Cash and funds flow",
          "Cash flow projection",
          "Interest calculations",
          "Payment performance of debtors"
        ]
      },
      {
        "title": "Banking",
        "items": [
          "Auto configured cheque printing",
          "Chequebook management",
          "Auto bank reconciliation (Auto BRS)",
          "Post-dated cheque management",
          "Payment advice & deposit slip",
          "E-payments"
        ]
      },
      {
        "title": "Manufacturing & Job Work",
        "items": [
          "Multi bill of material (BOM)",
          "Manufacturing journal",
          "Job order processing",
          "Job work processing"
        ]
      },
      {
        "title": "Delightful User Experience",
        "items": [
          "On the fly feature enablement and ledger creation",
          "Easily configure ledgers and vouchers with More Details",
          "Consistent top menu that helps with multi-tasking and better navigation",
          "Contextual right bar that helps get used to and take advantage of the product",
          "Intelligent setup manager for easy troubleshooting",
          "About page for easily getting support"
        ]
      },
      {
        "title": "MSME Payments",
        "items": ["Tracking of MSME payments and returns"]
      },
      {
        "title": "e-Invoicing",
        "items": [
          "Connected with IRP",
          "Single and bulk e-lnvoice generation",
          "e-Invoice cancellation",
          "Prevention, detection and correction to manage exceptions",
          "e-Invoice report",
          "IRN register"
        ]
      },
      {
        "title": "Cost Control and Cost Analysis",
        "items": [
          "Cost centre and profit centre management",
          "Set budgets & track variance",
          "Business forecasting using scenario management"
        ]
      },
      {
        "title": "Payroll Capabilities",
        "items": [
          "Multi pay slip printing and e-mailing",
          "Employee category/group-wise Pay Sheet",
          "Employee profile, group & category",
          "Employee pay structure management",
          "Attendance recording & pay process",
          "Payroll accounting",
          "Employee income tax with reports",
          "PF/ESI calculation & e-returns",
          "Payroll exception reports",
          "Employee profile report",
          "Payment advice",
          "Payroll statutory summary"
        ]
      },
      {
        "title": "Statutory Capabilities with Connected Experiences",        
        "items": [
          "Manage GST compliance",
          "Multi-GSTIN support in a single company",
          "Upload and filing of GSTR-1",
          "Upload of GSTR-3B",
          "GSTR-1 reconciliation",
          "GSTR-2B and GSTR-2A Reconciliation",
          "Annual GST computation for GSTR 9",
          "Track and report amendments",
          "CMPO8 and GSTR 4 support for composite dealers",
          "Tax deducted at source (TDS)",
          "Tax collected at source (TCS)"
        ]
      },    
      {
        "title": "e-Way Bill Connectivity",
        "items": [
          "Connected with NIC portal",
          "Single or bulk e-Way Bill generation",
          "Track e-Way Bill related activities",
          "Preview and Summary Reports",
          "Easy detection and correction of errors"
        ]
      },     
      {
        "title": "Internet-based Capabilities",
        "items": [
          "Tally Reports in Browser",
          "Secure remote access",
          "E-mailing of invoices and reports",
          "Integration with payment gateways",
          "Help & support",
          "License and user management",
          "TallyShop"
        ]
      },
      {
        "title": "Data Exchange Capabilities",
        "items": [
          "On-demand data synchronization",
          "Export reports in different formats like Excel, PDF, JPEG and HTML",
          "Export pivot for sales/purchase register",
          "Export & import of data through XML",
          "Tally ODBC",
          "Upload data to HTTP web server"
        ]
      },
      {
        "title": "Edit Log",
        "items": [
          "Tracks activities such as creation, alteration, and deletion for transactions and masters",
          "Get to know when and who made the changes",
          "Compare and know the version difference",
          "Filter the edited or deleted transaction"
        ]
      },
      {
        "title": "Data Security Capabilities",
        "items": [
          "Data backup & restore",
          "Multiple security controls",
          "User management",
          "Password policy management",
          "TallyVault",
          "TallyAudit"
        ]
      },  
      {
        "title": "Business Reports",
        "items": [
          "Discover easily, do more with GoTo/ SwitchTo",
          "Tailor-made reports with Change View, Basis of Values and Exception reports",
          "Reports save functionality",
          "Filter option in Reports / Reports filter in all reports"
        ]
      },
      {
        "title": "Accounting Reports",
        "highlight": true,
        "items": [
          "Ledger reports",
          "Cash/Bank books",
          "Purchase/Sales register (columnar)",
          "Bills receivables",
          "Bills payables"
        ]
      },
      {
        "title": "Financial Report",
        "highlight": true,
        "items": [
          "Balance sheet",
          "Profit & loss A/c",
          "Trial balance",
          "Ratio analysis"
        ]
      },
      {
        "title": "Inventory Report",
        "highlight": true,
        "items": [
          "Stock summary",
          "Stock ageing analysis",
          "Movement analysis",
          "Stock transfers",
          "Stock item cost analysis",
          "Location/Godown summary",
          "Stock item-wise profitability",
          "Order summary",
          "Batch summary (Mfg. & Exp. date)",
          "Re-order status reports",
          "Job costing analysis",
          "Job-work reports"
        ]
      },
      {
        "title": "Management Control Reports",
        "highlight": true,
        "items": [
          "Cost centre",
          "Cost category",
          "Budget",
          "Cash flow report and projection",
          "Scenario management",
          "Comparative reports"
        ]
      },                
      {
        "title": "Other Business Capabilities",
        "items": [
          "Dongle-based digital signature",
          "Digital signature on invoices and reports",
          "Edit Log for audit trail",
          "Logo printing",
          "Date based reporting",
          "Flexible financial periods",
          "Split financial year",
          "Flexible voucher numbering",
          "User defined voucher types",
          "Multi-language support",
          "Percentage based reporting",
          "Multi account reporting",
          "Context sensitive help",
          "Data migration from earlier versions of Tally"
        ]
      }
    ]
  }
  